<template>
    <div class="c-widget">
        <date-range-toggle
            v-if="format == 'full'"
            v-bind:value.sync="dateRangeTypeId"
            class="c-widget__date-range-toggle c-widget__top-right"
        >
        </date-range-toggle>
        <p v-if="0 && (isNaN(value) || null == value)">&mdash;</p>
        <text-primitive
            v-else
            :value="value"
            :class="'c-widget__text_position_top c-widget__text_position_left1 c-widget__text_size_medium'"
        ></text-primitive>
        <timeline
            class="c-widget__timeline"
            :datasets="datasets"
            :labels="labels"
            :options="options"
            :key="$vnode.key"
        ></timeline>
    </div>
</template>
<script>
import DateFormatter from "@/js/mixins/date-formatter.js";
import Timeseries from "@/js/mixins/timeseries.js";
import DateRange from "@/js/lookups/date-range";
export default {
    props: {
        definition: Object,
        format: {
            type: String,
            default: "small",
        },
        tasksStatisticsRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/base.js"))(
                    window.akita.urls.api + "/v1/tasks-statistics"
                );
            },
        },
        tasksHistoryRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/base.js"))(
                    window.akita.urls.api + "/v1/tasks-history"
                );
            },
        },
    },
    mixins: [DateFormatter, Timeseries],
    data() {
        let _this = this;
        return {
            dateRangeTypeId: 3,
            valueResponse: null,
            labels: [],
            datasets: [],
            options: {},
        };
    },
    components: {
        DateRangeToggle: function () {
            return import(
                "@/js/components/partials/widgets/controls/date-range.vue"
            );
        },
        TextPrimitive: function () {
            return import("@/js/components/partials/widgets/primitives/text");
        },
        Timeline: function () {
            return import(
                "@/js/components/partials/widgets/primitives/timeline"
            );
        },
    },
    created() {
        this.init();
    },
    watch: {
        definition: {
            handler: function () {
                this.init();
            },
            deep: true,
        },
        modifiers(newVal, oldVal) {
            this.init();
        },
        dateRangeTypeId() {
            this.loadTimeseries();
        },
    },
    computed: {
        valid() {
            return true;
        },
        value() {
            let key;
            switch (this.definition.statusId) {
                case 1:
                    key = "open_count";
                    break;
                case 2:
                    key = "completed_count";
                    break;
                case 5:
                    key = "skipped_count";
                    break;
                case 100:
                    key = "overdue_count";
                    break;
                default:
                    key = "total_count";
                    break;
            }
            return _.get(this.valueResponse, key);
        },
    },
    methods: {
        init() {
            this.valueResponse = null;
            this.labels = [];
            this.datasets = [];
            this.loadValue();
            this.loadTimeseries();
        },
        async loadValue() {
            let request = {
                params: {
                    q: [],
                    group_by: [],
                },
            };
            if (this.definition.userId) {
                request.params.q.push(
                    "assigned_to_id[eq]=" + this.definition.userId
                );
            }
            if (this.definition.playbookId) {
                request.params.q.push(
                    "playbook_id[eq]=" + this.definition.playbookId
                );
            }

            let response = await this.tasksStatisticsRepository.index(request);
            this.valueResponse = _.first(response.data.data);
        },
        async loadTimeseries() {
            let _this = this;

            /**
             * Clear the chart
             */
            this.labels = [];
            this.datasets = [];

            /**
             * Create a date range object from the specified ID
             */
            let dateRange = new DateRange(this.dateRangeTypeId || 3);

            /**
             * Create an empty array of labels for the date
             */
            this.labels = this.initializeDateRangeArray(
                dateRange.startDate(),
                this.$moment().toDate()
            );

            /**
             * Initialize an array to store the datas
             */
            let data = new Array(this.labels.length);

            let config = {
                params: {
                    q: [
                        "recorded_at[gte]=" +
                            dateRange.startDate().toISOString().split("T")[0],
                    ],
                    group_by: ["recorded_at"],
                    order_by: "recorded_at:desc",
                    per_page: data.length,
                },
            };

            if (this.definition.statusId) {
                config.params.q.push(
                    "status_id[eq]=" + this.definition.statusId
                );
            }
            if (this.definition.userId) {
                config.params.q.push(
                    "assigned_to_id[eq]=" + this.definition.userId
                );
            }

            if (this.definition.playbookId) {
                config.params.q.push(
                    "playbook_id[eq]=" + this.definition.playbookId
                );
            }

            /**
             * Query API
             */
            let response = await this.tasksHistoryRepository.index(config);

            for (let i = 0; i < response.data.data.length; i++) {
                let index = this.labels.indexOf(
                    response.data.data[i].recorded_at
                );
                let item = response.data.data[i];
                data[index] = parseInt(item.task_count);
            }

            this.datasets.push({
                data: data,
            });
        },
    },
};
</script>
